import React from "react";
import { Show, SimpleShowLayout, TextField, DateField, RichTextField } from 'react-admin';

export const CryptoKeyShow = (props) => (
	<Show {...props}>
		<SimpleShowLayout>
			<TextField source="address" />
			<TextField source="origin" />
			<TextField source="description" />
			<TextField source="public_key" />
		</SimpleShowLayout>
	</Show>
);